import { memo, useCallback } from 'react';
import { useSeStore } from '@/store/seStore';
import { Range } from '../Range';

export const SeSettings = memo(function SeSettings() {
  const { seVolume: volume, setSeVolume } = useSeStore();

  const handleSeVolumeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSeVolume(parseInt(e.target.value, 10));
    },
    [setSeVolume],
  );

  return (
    <section className="grid gap-16">
      <header className="flex items-center justify-between text-md">
        <h3 className="font-bold text-gray-800">効果音音量</h3>
        <b className="text-[1.2em] text-yellow-600">{volume}</b>
      </header>

      <Range
        value={volume}
        onChange={handleSeVolumeChange}
        ariaLabel="効果音音量"
        style={{
          background: `linear-gradient(to right, var(--color-orange-800) 0%, var(--color-yellow-500) ${volume}%, var(--color-white) ${volume}%, var(--color-white) 100%)`,
        }}
      />
    </section>
  );
});
